import type { ComponentType } from 'react';
import { USER_NAV, type MemberNavItem, type MemberScreenId } from '../navigation';
import { t } from '@services/i18n';
import { ScreenPlaceholder } from './ScreenPlaceholder';
import { UserDashboard } from './UserDashboard';
import { UserActivity } from './UserActivity';
import { UserBadges } from './UserBadges';
import { UserCampaigns } from './UserCampaigns';
import { UserStore } from './UserStore';
import { UserLeaderboard } from './UserLeaderboard';
import { UserHowToEarn } from './UserHowToEarn';
import { UserPrivacy } from './UserPrivacy';
import type { MemberScreenProps } from './types';

export type { MemberScreenProps } from './types';

function placeholder(item: MemberNavItem): ComponentType<MemberScreenProps> {
  const C: ComponentType<MemberScreenProps> = () => <ScreenPlaceholder title={t(item.labelKey, item.label)} />;
  C.displayName = `Placeholder(${item.id})`;
  return C;
}

/** Member screen registry; real screens override their entry as ported. */
export const MEMBER_SCREENS: Record<MemberScreenId, ComponentType<MemberScreenProps>> = {
  ...(Object.fromEntries(USER_NAV.map((n) => [n.id, placeholder(n)])) as Record<
    MemberScreenId,
    ComponentType<MemberScreenProps>
  >),
  'u-dashboard': UserDashboard,
  'u-activity': UserActivity,
  'u-badges': UserBadges,
  'u-campaigns': UserCampaigns,
  'u-store': UserStore,
  'u-leaderboard': UserLeaderboard,
  'u-howto': UserHowToEarn,
  'u-privacy': UserPrivacy,
};
